import { render, staticRenderFns } from "./waterlevelgauge.vue?vue&type=template&id=386b5b97&scoped=true&"
import script from "./waterlevelgauge.vue?vue&type=script&lang=js&"
export * from "./waterlevelgauge.vue?vue&type=script&lang=js&"
import style0 from "./waterlevelgauge.vue?vue&type=style&index=0&id=386b5b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b5b97",
  null
  
)

export default component.exports